module.exports = __webpack_public_path__ + "static/google-play-6044d4aed376b4101942d72e3d7aa70e.svg";